/**
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; under version 2
 * of the License (non-upgradable).
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 *
 * Copyright (c) 2021-2023 (original work) Open Assessment Technologies SA
 */

/**
 * Convert an action to routeKey
 * @param {string} action - action
 * @returns {string} - converted action to route key
 */
export default function (action) {
    let routeKey = '';
    switch (action) {
        case 'extend_time':
            routeKey = 'extendTime';
            break;
        case 'reset_extra_time':
            routeKey = 'resetExtraTime';
            break;
        case 'update':
            routeKey = 'extend_time';
            break;
        default:
            routeKey = action;
            break;
    }
    return routeKey;
}
